<template>
  <v-dialog
    v-model="show"
    :width="props && props.width || '480'"
  >
    <v-card class="dialog">
      <div class="dialog__head">
        <h1 class="dialog__title">
          {{ header }}
        </h1>

        <v-btn
          icon
          class="pa-0"
          @click="show = !show"
        >
          <img
            src="@/assets/img/icon_close.svg"
            alt="close"
          >
        </v-btn>
      </div>

      <div class="dialog__text">
        <div v-html="text" />
      </div>

      <component
        :is="component"
        v-bind="props"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      show: false,
    };
  },

  computed: {
    ...mapState('dialog', [
      'isShown',
      'header',
      'text',
      'component',
      'props',
    ]),
  },

  methods: {
    ...mapActions('dialog', [
      'clearDialog',
    ]),
  },

  watch: {
    isShown(newValue, oldValue) {
      if (newValue && (newValue !== oldValue)) {
        if (!this.$options.components[this.component]) {
          this.$options.components[this.component] = () => import(`@/components/Dialog/${this.component}.vue`);
        }
        this.show = true;
      } else {
        this.show = false;
      }
    },
    show(newValue, oldValue) {
      if (!newValue && (newValue !== oldValue)) {
        this.clearDialog();
      }
    },
  },
};
</script>

<style lang="scss">
.dialog{
  padding: 24px;
  &__head {
    display:flex;
    justify-content:space-between;
  }
  &__title {
    font-size:20px;
    margin-bottom:8px;
    font-weight:700;
  }
  &__text {
    font-size:12px;
    margin-bottom:24px;
  }
}
</style>
